<script setup lang="ts">
interface Props {
  isError?: boolean
  message?: string
}

defineProps<Props>()
</script>

<template>
  <div
    v-if="message"
    :class="{
      'bg-white rounded-new-xl px-new-xl py-2.5 border-t-[1.5px] shadow-md mb-12 text-new-neutral-700 text-new-sm': true,
      'border-new-red-500': isError,
      'border-new-green-500': !isError,
    }"
  >
    {{ message }}
  </div>
</template>
